<template>
	<!-- 整个div都支持拖入下载 -->
	<div class="main-fn-all-body" @dragover.prevent="" @drop="drop">
		<!-- 固定的页头 在添加文件后会有额外的按钮  点击不触发上传文件  封装为组件5个页面公用并调用传入的不同的函数方法-->
		<mainFnHead
			:ext="ext"
			:isEmpty="!runner.files.length"
			@push="push"
			@clear="runner.clear()"
		></mainFnHead>
		<!-- 可拉伸的功能窗口 分为 初次进入时的页面 以及 导入文件后的功能页面 动态组件切换-->
		<component
			:is="mainFnBodyId"
			:titleH1="titleH1"
			:titleP="titleP"
			:imgSrc="imgSrc"
			:imgText="imgText"
			:shuchuStyle="shuchuStyle"
			:files="runner.files"
			:options="runner.options"
			:outputExt="shuchuGeShi"
			:ext="ext"
			@push="push"
			@remove="remove"
			@openLimitBody1="openLimitBody1"
			@globalApplication="globalApplication"
			ref="main_body"
			:isGlobalApplicationOver="isGlobalApplicationOver"
			:nowCompressedFormat="'图片压缩'"
		></component>
	</div>
</template>

<script>
import mainFnHead from "./../../mycomponents/mainFnHead";
import mainFnBodyFirst from "../../mycomponents/mainFnBodyFirst";
import mainFnBodySecend from "../../mycomponents/mainFnBodySecend";
import ImageConverter from "../../lib/ImageConveter";
import {watchLocal} from "../../common/utils";
import hdapi from "../../common/hdapi";
const fs = require("fs");

export default {
	props: ["openLimitBody"],
	data() {
		return {
			runner: watchLocal("image-converter", new ImageConverter()),
			titleH1: this.$t("picturecompression"),
			titleP: this.$t("supportjpgpnggifbmpformats"),
			imgSrc: "pic_tupianyasuo_big.png",
			imgText: "icon slt img.svg",
			ext:
				hdapi.platform == "WIN"
					? "png,jpg,gif,bmp,jpeg,ai,svg,webp,aai,avif,avs,bmp2,bmp3,cals,cgm,cin,cube,dcm,dcx,dds,dib,djvu,dot,drem,emf,epdf,epi,eps,eps2,eps3,epsf,epsi,exr,farbfeld,fax,fig,fl32,elie,frem,gplt,hdr,hpgl,hrz,jbig,jng,jp2,j2c,j2k,jxl,kernel,man,mat,miff,mng,mpr,msl,mtv,mvg,otb,p7,pam,clipboard,pbm,pcd,pcds,pcx,pdb,pes,pfa,pfb,pfm,pgm,phm,pict,pix,png8,png00,png24,png32,png48,png64,pnm,pocketmod,ppm,ps,ps2,ps3,psb,ptif,pwp,rad,rgb565,rla,rle,sct,sfw,sgi,sid,mrsid,sun,text,tga,tiff,tim,ttf,vicar,vife,wbmp,wmf,wpg,xbm,xcf,xpm,xwd,arw,brf,cip,cmyk,cmyka,cr2,crw,cut,dng,epdf,gray,graya,heic,ico,isobrl,isobrl6,json,mono,mrw,nef,orf,pcl,pef,psd,raf,rgb,rgba,shtml,sparsecolor,svg ,ubrl,ubrl6,uil,uyvy,viff ,webp,x,x3f,ycbcr,ycbcra ,yuv"
					: "jpg,jpeg,png,psd,tiff,xcf,gif,bmp,tga,miff,ico,dcm,xpm,pcx,fits,ppm,pgm,mng,dds,otb,psb",
			shuchuStyle: this.$t("jpgstyle"),
			shuchuGeShi: "jpg",
			isGlobalApplicationOver: true,
		};
	},
	computed: {
		mainFnBodyId() {
			return this.runner.files.length ? mainFnBodySecend : mainFnBodyFirst;
		},
		isVIPlimit() {
			return this.$app.VIPlevel;
		},
	},
	watch: {
		isVIPlimit(newval, oldval) {
			if (newval && oldval == 0) {
				for (let x of this.runner.files) {
					if (x.state == 6 || x.size > 200 * 1024) {
						if (window.store.isYsOver) {
							x.state = 1;
							// x.progress = 0;
						} else {
							x._timeOut1 = setInterval(function () {
								if (window.store.isYsOver) {
									x.state = 1;
									// x.progress = 0;
									clearInterval(x._timeOut1);
								}
								console.log("还未清除");
							}, 1000);
						}
					}
				}
			} else if (newval == 0) {
				for (let x of this.runner.files) {
					if (
						x.is_gx_quality ||
						x.is_gx_resolution ||
						x.is_gx_filesize ||
						this.runner.options.global_application
					) {
						if (window.store.isYsOver) {
							x.is_gx_quality = false;
							x.is_gx_resolution = false;
							x.is_gx_filesize = false;
							this.runner.options.global_application = false;
						} else {
							x._timeOut2 = setInterval(function () {
								if (window.store.isYsOver) {
									x.is_gx_resolution = false;
									x.is_gx_filesize = false;
									x.is_gx_quality = false;
									this.runner.options.global_application = false;
									clearInterval(x._timeOut2);
								}
								console.log("还未清除");
							}, 1000);
						}
					}
				}
			}
		},
	},
	components: {
		mainFnHead,
		mainFnBodyFirst,
	},
	methods: {
		remove(file) {
			this.runner.remove(file);
		},
		push(e) {
			console.log("push", e);
			this.$app.isDrOver = false;
			this.runner.addFiles(e).then(() => {
				console.log("添加完成");
				this.$app.isDrOver = true;
				if (this.runner.options.global_application) {
					console.log("需要给后续导入文件修改参数");
					if (!this.$refs.main_body.globalApplication_timeout)
						this.$refs.main_body.create_globalApplication_time(true);
				}
			});
		},
		drop(e) {
			//拖拽上传
			console.log(e);
			let dropFiles = e.dataTransfer.files;
			// console.log(dropFiles);
			let todoList = Array.from(dropFiles);
			// console.log(todoList);
			if (dropFiles.length > 0) {
				let arr = [];
				arr = this.getAllFile(todoList);
				// console.log("arr2", arr);
				if (arr.length > 0) this.push(arr);
				else this.$toast.show(this.$t("pleaseselectpictureformatfile"));
			}
		},
		getAllFile(arr) {
			let a = [];
			let b = arr
				.map((item) => item.path)
				.filter((x) => {
					let e = hdapi.extname(x).toLowerCase();
					if (e) {
						return hdapi.hasExt(x, this.ext);
					} else {
						console.log("该文件为文件夹");
						let b = this.getInFileFiles(x);
						a.push(b);
						console.log("b", b);
						return false;
					}
				});
			a.push(...b);
			console.log("arr1", a);
			return a;
		},
		getInFileFiles(url) {
			let files = fs.readdirSync(url);
			console.log("files", files);
			let _this = this;
			let obj = {};
			for (let file of files) {
				var Path = hdapi.join(url, file);
				if (fs.statSync(Path).isDirectory()) {
					// recurse
					let a = _this.getInFileFiles(Path);
					obj = Object.assign(obj, a);
					continue;
				}
				if (!hdapi.hasExt(Path, this.ext)) continue;
				obj[Path] = Path;
				// console.log("curpath", curPath);
				/**
				 * fs.statSync同步读取文件夹文件，如果是文件夹，在重复触发函数
				 */
			}
			obj["url"] = url;
			return obj;
		},
		openLimitBody1() {
			this.$emit("openLimitBody");
		},
		globalApplication(file) {
			this.isGlobalApplicationOver = false;
			console.log("file", file);
			for (let x of this.runner.files) {
				if (x.width > 0 && file.width > 0) {
					if (file.is_gx_resolution) {
						x.is_gx_resolution = file.is_gx_resolution;
						x.gx_aspect_ratio = file.gx_aspect_ratio;
						x.gx_height = (x.height * x.gx_aspect_ratio) / 100;
						x.gx_width = (x.width * x.gx_aspect_ratio) / 100;
					} else {
						x.is_gx_resolution = file.is_gx_resolution;
					}
				}
				if (file.is_gx_quality) {
					x.is_gx_quality = file.is_gx_quality;
					x.gx_compressLevel = file.gx_compressLevel;
				} else {
					x.is_gx_quality = file.is_gx_quality;
				}
				if (file.is_gx_filesize) {
					if (file.gx_filesize > x.size / 1024) {
						console.log("不修改");
					} else {
						x.is_gx_filesize = file.is_gx_filesize;
						x.gx_filesize = file.gx_filesize;
					}
				} else {
					x.is_gx_filesize = file.is_gx_filesize;
				}
			}
			this.isGlobalApplicationOver = true;
		},
	},
	created() {
		this.runner.options.compressLevel = 70;
		this.runner.options.global_application = false;
	},
};
</script>

<style>
.main-fn-all-body {
	width: 100%;
	height: 100%;
	/* background-color: rgb(167,80,167); */
}
</style>
